import compact from 'lodash/compact';
import React, { useState } from 'react';

import { ToggleButton } from '@mui/material';
import { updateProfile } from '@utils/backend-api/userProfile';

import StepContainer from './StepContainer';

export interface Topic {
  key: string;
  label: string;
  default: boolean;
}

interface StepTopicsProps {
  topics: Topic[];
  nextStep: () => void;
}

const StepTopics = ({ topics, nextStep }: StepTopicsProps) => {
  const [selectedTopics, setSelectedTopics] = useState(
    compact(topics.map((i) => (i.default ? i.key : null)))
  );
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState();

  const handleButtonToggle = (event) => {
    setSelectedTopics((prevSelectedTopics) =>
      prevSelectedTopics.includes(event.target.value)
        ? prevSelectedTopics.filter((prevKey) => prevKey !== event.target.value)
        : [...prevSelectedTopics, event.target.value]
    );
  };

  return (
    <StepContainer
      heading="Choose Your Interests"
      subheading="What topics do you care about?"
      nextStep={nextStep}
      disableContinue={isSaving}
      error={error}
      onContinue={async () => {
        setIsSaving(true);
        try {
          await updateProfile({ topics: selectedTopics });
          nextStep();
        } catch (err) {
          setError(err.message);
        }
        setIsSaving(false);
      }}
    >
      {topics?.map((t) => (
        <ToggleButton
          className="titoggle"
          key={t.key}
          value={t.key}
          selected={selectedTopics.includes(t.key)}
          disableRipple
          onChange={handleButtonToggle}
        >
          {t.label}
        </ToggleButton>
      ))}
    </StepContainer>
  );
};

export default StepTopics;
